<template lang="pug">
    Tabs.statistics
        el-card(shadow="always")
            //- .under-construction
            //-     i.el-icon-fa-snowplow.fas
            //-     h4 {{ $t('Under Construction') }}
            //-     p {{ $t('Come back another time') }}

            el-form.filters.flex-row(
                v-if="!(error && [401, 403].includes(error.code))"
                ref="form"
            )
                .left.flex-row
                    el-form-item(:label="$t('Domain')")
                        el-select(
                            placeholder=""
                            filterable
                            v-model="domain"
                            autocomplete="no-fill"
                            :disabled="domainOptions.length <= 1"
                        )
                            el-option(v-for="domain in domainOptions" :key="domain.label" :label="domain.label" :value="domain.label")
                .center.flex-row
                    el-form-item(:label="$t('Daterange')")
                        el-select(
                            v-if="period === 'year'"
                            v-model="selectedDecade"
                            placeholder=""
                            autocomplete="no-fill"
                        )
                            el-option(v-for="d in decadeOptions" :key="d.value" :label="d.label" :value="d.value")
                        el-date-picker(
                            v-else
                            v-model="date"
                            :type="datepickerType"
                            :format="datepickerFormat"
                            prefix-icon="far el-icon-fa-calendar-alt"
                            :unlink-panels="true"
                            :clearable="false"
                            :picker-options="{ firstDayOfWeek:1, disabledDate }"
                        )
                .right.flex-row
                    el-form-item(:label="$t('Period')")
                        el-select(
                            placeholder=""
                            filterable
                            v-model="period"
                            autocomplete="no-fill"
                        )
                            el-option(
                                v-for="period in periodOptions"
                                :key="period.key"
                                :label="period.label"
                                :value="period.key"
                            )
            //- el-button.prev(
            //-     v-if="!loading"
            //-     size="mini"
            //-     type="primary"
            //-     icon="el-icon-arrow-left"
            //-     circle
            //-     @click="prev"
            //- )
            //- el-button.next(
            //-     v-if="!loading"
            //-     size="mini"
            //-     type="primary"
            //-     icon="el-icon-arrow-right"
            //-     circle
            //-     @click="next"
            //-     :disabled="isNextDisabled"
            //- )

            SiteViewsChart(
                v-if="domain"
                :domain="domain"
                :daterange="daterange"
                :date="date"
                :period="period"
                @click="handleClick"
            )

            ShopSalesChart(
                v-if="domain && enabledExtensions.includes('shop')"
                :domain="domain"
                :daterange="daterange"
                :date="date"
                :period="period"
                @click="handleClick"
            )

            .side-by-side
                TargetViewsChart(
                    v-if="domain && enabledExtensions.includes('marketing')"
                    :domain="domain"
                    :daterange="daterange"
                    :date="date"
                    :period="period"
                )

                ReferrerChart(
                    v-if="domain"
                    :domain="domain"
                    :daterange="daterange"
                    :date="date"
                    :period="period"
                )
</template>

<i18n>
{
    "de": {
        "All Pages Report": "Aufrufe insgesamt",
        "Siteviews": "Seitenaufrufe",
        "Show Siteviews": "Seitenaufrufe anzeigen",
        "Hide Siteviews": "Seitenaufrufe verbergen",
        "Unique Visitors": "Besucher",
        "Show Visitors": "Besucher anzeigen",
        "Hide Visitors": "Besucher verbergen",
        "Currency": "Währung",
        "Daterange": "Zeitraum",
        "Period": "Intervall",
        "Hourly": "Stündlich",
        "Daily": "Täglich",
        "Weekly": "Wöchentlich",
        "Monthly": "Monatlich",
        "Yearly": "Jährlich",
        "Domain": "Domain",
        "Week": "Kalenderwoche",
        "The summary will be processed asynchronously": "Die Zusammenfassung wird asynchron verarbeitet",
        "You will be notified once the summary is completed": "Sie werden benachrichtigt, sobald die Zusammenfassung abgeschlossen ist"
    }
}
</i18n>

<script>
import { useAuthStore, useSetupStore } from '@/stores'
import { appNow, appGetUnixTime, appFromUnixTime } from '@/utils/timezone'

// import compareAsc from 'date-fns/compareAsc';

// import startOfHour from 'date-fns/startOfHour';
// import endOfHour from 'date-fns/endOfHour';

import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';

import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';

import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';

import startOfYear from 'date-fns/startOfYear';
import endOfYear from 'date-fns/endOfYear';

import startOfDecade from 'date-fns/startOfDecade';
import endOfDecade from 'date-fns/endOfDecade';

import getUnixTime from 'date-fns/getUnixTime'
import fromUnixTime from 'date-fns/fromUnixTime'

import addHours from 'date-fns/addHours'
import subHours from 'date-fns/subHours'

import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'

import addWeeks from 'date-fns/addWeeks'
import subWeeks from 'date-fns/subWeeks'

import addMonths from 'date-fns/addMonths'
import subMonths from 'date-fns/subMonths'

import addYears from 'date-fns/addYears'
import subYears from 'date-fns/subYears'

// import differenceInHours from 'date-fns/differenceInHours'
// import differenceInDays from 'date-fns/differenceInDays'
// import differenceInWeeks from 'date-fns/differenceInWeeks'
// import differenceInMonths from 'date-fns/differenceInMonths'
// import differenceInYears from 'date-fns/differenceInYears'

import Tabs from '@/views/cms/Marketing/Partials/Tabs'
import SiteViewsChart from './Partials/SiteViewsChart'
import ShopSalesChart from './Partials/ShopSalesChart'
import TargetViewsChart from './Partials/TargetViewsChart'
import ReferrerChart from './Partials/ReferrerChart'

export default {
    name: 'Statistics',
    data() {
        return {
            loading: false,
            error: false,
            filters: {
                period: 'day',
                start: null,
                end: null,
                domain: _.get(this.domainOptions, '0.label'),
            }
        }
    },
    components: {
        Tabs,
        SiteViewsChart,
        ShopSalesChart,
        TargetViewsChart,
        ReferrerChart,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            // TODO
            // if (reload) this.refresh();
        },
    },
    computed: {
        datepickerType() {
            let type;

            switch (this.filters.period) {
                case 'hour':
                    type = 'date'
                    break;

                case 'week':
                    type = 'month'
                    break;

                case 'month':
                    type = 'year'
                    break;

                case 'year':
                    type = 'year'
                    break;

                default:
                // case 'day':
                    type = 'week'
                    break;
            }

            return type;
        },
        datepickerFormat() {
            let format;

            switch (this.filters.period) {
                case 'hour':
                    format = this.$t('yyyy-MM-dd')
                    break;

                case 'week':
                    format = 'MMMM yyyy'
                    break;

                case 'month':
                    format = 'yyyy';
                    break;

                case 'year':
                    format = 'yyyy';
                    break;

                default:
                // case 'day':
                    format = `[${this.$t('Week')}] WW`
                    break;
            }

            return format;
        },
        domainOptions() {
            let options = [];

            const domains = _.get(this.activeCms, 'domains') || [];
            domains.forEach(el => {
                options.push({
                    id: el.id,
                    label: el.base_url
                });
            })

            return options;
        },
        domain: {
            get() {
               return _.get(this.filters, 'domain') || _.get(this.domainOptions, '0.label')
            },
            set(value) {
                this.filters.domain = value;
            }
        },
        daterange: {
            get() {
                let daterange = []

                if (! this.filters.start || ! this.filters.end) {
                    switch (this.period) {
                        case 'hour':
                            daterange = [ startOfDay(appNow()), endOfDay(appNow()) ];
                            break;

                        case 'week':
                            daterange = [ startOfMonth(appNow()), endOfMonth(appNow()) ];
                            break;

                        case 'month':
                            daterange = [ startOfYear(appNow()), endOfYear(appNow()) ];
                            break;

                        case 'year':
                            daterange = [ startOfDecade(appNow()), endOfDecade(appNow()) ];
                            break;

                        default:
                        // case 'day':
                            daterange = [ startOfWeek(appNow(), { weekStartsOn: 1 }), endOfWeek(appNow(), { weekStartsOn: 1 }) ];
                            break;

                    }
                } else {
                    daterange = [ appFromUnixTime(this.filters.start), appFromUnixTime(this.filters.end) ]
                }

                return daterange;
            },
            set(value) {
                if (value && value.length >= 2) {
                    this.filters.start = appGetUnixTime(value[0])
                    this.filters.end = appGetUnixTime(endOfDay(value[1]))
                }
            }
        },
        date: {
            get() {
                let date = appNow()
                if (this.filters.start && this.filters.end) date = appFromUnixTime((this.filters.start + this.filters.end) / 2)
                return date
            },
            set(value) {
                switch (this.period) {
                    case 'hour':
                        this.filters.start = appGetUnixTime(startOfDay(value, { weekStartsOn: 1 }))
                        this.filters.end = appGetUnixTime(endOfDay(value, { weekStartsOn: 1 }))
                        break;

                    case 'week':
                        this.filters.start = appGetUnixTime(startOfWeek(startOfMonth(value), { weekStartsOn: 1 }))
                        this.filters.end = appGetUnixTime(endOfWeek(endOfMonth(value), { weekStartsOn: 1 }))
                        break;

                    case 'month':
                        this.filters.start = appGetUnixTime(startOfYear(value, { weekStartsOn: 1 }))
                        this.filters.end = appGetUnixTime(endOfYear(value, { weekStartsOn: 1 }))
                        break;

                    case 'year':
                        this.filters.start = appGetUnixTime(startOfDecade(value, { weekStartsOn: 1 }))
                        this.filters.end = appGetUnixTime(endOfDecade(value, { weekStartsOn: 1 }))
                        break;

                    default:
                    // case 'day':
                        this.filters.start = appGetUnixTime(startOfWeek(value, { weekStartsOn: 1 }))
                        this.filters.end = appGetUnixTime(endOfWeek(value, { weekStartsOn: 1 }))
                        break;
                }
            }
        },
        periodOptions() {
            return [
                {
                    key: 'hour',
                    label: this.$t('Hourly'),
                },
                {
                    key: 'day',
                    label: this.$t('Daily'),
                },
                {
                    key: 'week',
                    label: this.$t('Weekly'),
                },
                {
                    key: 'month',
                    label: this.$t('Monthly'),
                },
                {
                    key: 'year',
                    label: this.$t('Yearly'),
                },
            ]
        },
        period: {
            get() {
                return _.get(this.filters, 'period') || 'day'
            },
            set(value) {
                this.filters.period = value

                const start = this.filters.start || appGetUnixTime(this.daterange[0]);
                const end = this.filters.end || appGetUnixTime(this.daterange[1]);

                const midpoint = appFromUnixTime((start + end) / 2);

                switch (this.filters.period) {
                    case 'hour':
                        this.filters.start = appGetUnixTime(startOfDay(midpoint, { weekStartsOn: 1 }));
                        this.filters.end = appGetUnixTime(endOfDay(midpoint, { weekStartsOn: 1 }));
                        break;

                    case 'week':
                        this.filters.start = appGetUnixTime(startOfWeek(startOfMonth(midpoint), { weekStartsOn: 1 }));
                        this.filters.end = appGetUnixTime(endOfWeek(endOfMonth(midpoint), { weekStartsOn: 1 }));
                        break;

                    case 'month':
                        this.filters.start = appGetUnixTime(startOfYear(midpoint, { weekStartsOn: 1 }));
                        this.filters.end = appGetUnixTime(endOfYear(midpoint, { weekStartsOn: 1 }));
                        break;

                    case 'year':
                        this.filters.start = appGetUnixTime(startOfDecade(midpoint, { weekStartsOn: 1 }));
                        this.filters.end = appGetUnixTime(endOfDecade(midpoint, { weekStartsOn: 1 }));
                        break;

                    default:
                    // case 'day':
                        this.filters.start = appGetUnixTime(startOfWeek(midpoint, { weekStartsOn: 1 }));
                        this.filters.end = appGetUnixTime(endOfWeek(midpoint, { weekStartsOn: 1 }));
                        break;
                }
            }
        },
        isSuperUser() {
            return useAuthStore().isSuperUser;
        },
        isOwner() {
            return useAuthStore().isOwner;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        decadeOptions() {
            const currentDecade = Math.floor(appNow().getFullYear() / 10) * 10
            const cmsCreatedAt = _.get(this.activeCms, 'created_at')
            const earliestDecade = cmsCreatedAt
                ? Math.floor(appFromUnixTime(cmsCreatedAt).getFullYear() / 10) * 10
                : currentDecade - 10
            const options = []
            for (let decade = currentDecade; decade >= earliestDecade; decade -= 10) {
                options.push({ value: decade, label: decade + ' - ' + (decade + 9) })
            }
            return options
        },
        selectedDecade: {
            get() {
                if (this.filters.start) {
                    return Math.floor(appFromUnixTime(this.filters.start).getFullYear() / 10) * 10
                }
                return Math.floor(appNow().getFullYear() / 10) * 10
            },
            set(value) {
                this.filters.start = appGetUnixTime(new Date(value, 0, 1))
                this.filters.end = appGetUnixTime(new Date(value + 9, 11, 31, 23, 59, 59))
            },
        },
    },
    methods: {
        disabledDate(date) {
            let disabled = false;

            // return date > new Date();
            switch (this.period) {
                case 'hour':
                    disabled = date > endOfDay(appNow());
                    break;

                case 'week':
                    disabled = date > endOfMonth(appNow());
                    break;

                case 'month':
                    disabled = date > endOfYear(appNow());
                    break;

                case 'year':
                    disabled = date > endOfDecade(appNow());
                    break;

                default:
                // case 'day':
                    disabled = date > endOfWeek(appNow(), { weekStartsOn: 1 })
                    break;
            }

            return disabled;
        },
        isNextDisabled() {
            let disabled = this.date > appNow();

            switch (this.period) {
                case 'hour':
                    disabled = addDays(startOfDay(this.date), 1) > appNow();
                    break;

                case 'week':
                    disabled = addMonths(startOfMonth(this.date), 1) > appNow();
                    break;

                case 'month':
                    disabled = addYears(startOfYear(this.date), 1) > appNow();
                    break;

                case 'year':
                    disabled = addYears(startOfDecade(this.date), 10) > appNow();
                    break;

                default:
                // case 'day':
                    disabled = addWeeks(startOfWeek(this.date), 1) > appNow();
                    break;
            }

            return disabled;
        },
        next() {
            let date = this.date

            switch (this.period) {
                case 'hour':
                    date = addDays(this.date, 1);
                    break;

                case 'week':
                    date = addMonths(this.date, 1);
                    break;

                case 'month':
                    date = addYears(this.date, 1);
                    break;

                case 'year':
                    date = addYears(this.date, 10);
                    break;

                default:
                // case 'day':
                    date = addWeeks(this.date, 1);
                    break;
            }

            this.date = date
        },
        prev() {
            let date = this.date

            switch (this.period) {
                case 'hour':
                    date = subDays(this.date, 1);
                    break;

                case 'week':
                    date = subMonths(this.date, 1);
                    break;

                case 'month':
                    date = subYears(this.date, 1);
                    break;

                case 'year':
                    date = subYears(this.date, 10);
                    break;

                default:
                // case 'day':
                    date = subWeeks(this.date, 1);
                    break;
            }

            this.date = date
        },
        handleClick(index) {
            let period, date
            switch (this.period) {
                case 'week':
                    period = 'day';
                    date = addWeeks(appFromUnixTime(this.filters.start), index);
                    this.filters.start = appGetUnixTime(startOfWeek(date, { weekStartsOn: 1 }));
                    this.filters.end = appGetUnixTime(endOfWeek(date, { weekStartsOn: 1 }));
                    break;

                case 'month':
                    period = 'week';
                    date = addMonths(appFromUnixTime(this.filters.start), index);
                    this.filters.start = appGetUnixTime(startOfWeek(startOfMonth(date), { weekStartsOn: 1 }));
                    this.filters.end = appGetUnixTime(endOfWeek(endOfMonth(date), { weekStartsOn: 1 }));
                    break;

                case 'year':
                    period = 'month';
                    date = addYears(appFromUnixTime(this.filters.start), index);
                    this.filters.start = appGetUnixTime(startOfYear(date, { weekStartsOn: 1 }));
                    this.filters.end = appGetUnixTime(endOfYear(date, { weekStartsOn: 1 }));
                    break;

                default:
                // case 'day':
                    period = 'hour';
                    date = addDays(appFromUnixTime(this.filters.start), index);
                    this.filters.start = appGetUnixTime(startOfDay(date));
                    this.filters.end = appGetUnixTime(endOfDay(date));
                    break;
            }

            if (period) {
                this.filters.period = period;
            }
        }
    },
}
</script>

<style lang="sass" scoped>
.statistics
    isolation: isolate
.filters
    justify-content: space-between
    position: sticky
    top: 0
    margin: -1rem
    margin-bottom: 0
    padding: 1rem
    padding-bottom: 0
    background: rgba(255, 255, 255, 0.5)
    backdrop-filter: blur(10px)
    z-index: 10
.chart-container + .chart-container
    margin-top: 3rem
.chart-container::v-deep .no-data
    background-color: #f5f7fa
    border-radius: 4px
.side-by-side
    display: flex
    gap: 2rem
    margin-top: 3rem
    .chart-container
        flex: 1
        min-width: 0
    .referrer-chart
        flex: 0 0 500px
        max-width: 500px
    .chart-container + .chart-container
        margin-top: 0
    @media (max-width: 900px)
        flex-direction: column
        .chart-container + .chart-container
            margin-top: 3rem
</style>
